<template>
  <div :class="[style['bottom-panel'], style['panel-timer']]">
    <time-picker
      :selected-time="selectedTime"
      :enabled-times="timeSettings.enabled_times"
      :update-selected-time="updateSelectedTime"
    />
    <panel-control :close-only="isUsedForFormTemplate" @bottomPanelSend="bottomPanelSend" />
  </div>
</template>

<script>
import TimePicker from '../Components/TimePicker.vue'
import PanelControl from '../Components/PanelControl.vue'
import { Chat } from 'src/apis'
import style from '../scss/_bottompanel.scss'
import { useBottomPanelStore } from 'Store/bottom-panel'
import { useDatepickerStore } from 'Store/datepicker'

export default {
  components: {
    TimePicker,
    PanelControl
  },

  setup() {
    return {
      bottomPanelStore: useBottomPanelStore(),
      datepickerStore: useDatepickerStore()
    }
  },

  data() {
    return {
      style
    }
  },

  computed: {
    timeSettings() {
      return this.datepickerStore.settings || {}
    },

    selectedTime: {
      get() {
        return this.timeSettings.currentTime || ''
      },

      set(val) {
        this.datepickerStore.setTimeSettings({
          ...this.timeSettings,
          currentTime: val
        })
      }
    },

    isUsedForFormTemplate() {
      return this.bottomPanelStore.inputFor === 'TemplateForm'
    }
  },

  methods: {
    bottomPanelSend() {
      Chat.sendMessage(this.selectedTime)
      this.bottomPanelStore.setBottomPanelComponent()
    },
    updateSelectedTime(timeString) {
      this.selectedTime = timeString

      if (this.isUsedForFormTemplate) {
        this.bottomPanelStore.setBottomPanelComponent()
      }
    }
  }
}
</script>
